package nacholab.supplies.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import nacholab.supplies.MainViewModel
import nacholab.supplies.pages.authentication.AuthenticationScreen
import nacholab.supplies.pages.authentication.CodeVerificationScreen
import nacholab.supplies.pages.mainscreen.MainScreen
import org.jetbrains.compose.web.css.Color
import org.koin.compose.koinInject

@Page
@Composable
fun HomePage() {
    val vm = MainViewModel(koinInject(), koinInject())
    val state by vm.state

    vm.initialize()

    Box(
        modifier = Modifier
            .fillMaxSize()
            .fontFamily("Sanva")
    ){
        when {
            state.isAuthenticated -> MainScreen(vm)
            state.waitingForCodeVerification -> CodeVerificationScreen(vm)
            else -> AuthenticationScreen(vm)
        }

        if (state.suppliesLoadingError!=null){
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color("#90909090"))
                    .onClick { vm.clearSuppliesLoadingError() },
                contentAlignment = Alignment.Center
            ){
                state.suppliesLoadingError?.let { SpanText(it) }
            }
        }
    }
}
